import { Link } from "react-router-dom";

function Wordmark() {
  return (
    <Link to="/" className="flex items-center gap-2" data-testid="wordmark" aria-label="Project in a Box home">
      <span className="display-title text-xl sm:text-2xl text-brand-navy leading-none">
        PROJECT IN A <span className="text-brand-orange">BOX</span>
      </span>
    </Link>
  );
}

export default function Header() {
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-brand-navy/10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Wordmark />
      </div>
    </header>
  );
}
